<block>
  <block-title><h2>{{ 'event.related' | translate }}</h2></block-title>
  <block-content>
    @if (!loading && data.length) {
      <div class="row">
        @for (item of data; track item) {
          <div class="col-6 sm-12">
            <div class="entry" [routerLink]="[item.path]">
              @if (item.fieldEventMainDate) {
                <span class="entry__date"
                  >{{ 'time.' + (item.fieldEventMainDate | weekday: "unix") |
                  translate }}, {{ item.fieldEventMainDate | date: "dd.MM.yyyy"
                  }}</span
                  >
                }
                <h3 class="entry__title">{{ item.title }}</h3>
                @if (item.person) {
                  <span
                    class="entry__author"
                    tabindex="0"
                    attr.aria-label="{{'author.author' | translate}} {{ item.person }}"
                    >{{ item.person }}</span
                    >
                  }
                </div>
              </div>
              <!--/col-6-->
            }
          </div>
          <!--/row-->
        }

        @if (!loading && !data.length) {
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                {{ 'event.related_no_results' | translate }}
              </div>
              <!--/text-center-->
            </div>
            <!--/col-12-->
          </div>
          <!--/row-->
        }

        @if (loading) {
          <loader></loader>
        }
      </block-content>
    </block>
